"use client";

import React, { useEffect } from "react";

import { assignSettingRSCLoggedOutBrandPage } from "@faire/retailer/settings/assignSettingRscLoggedOutBrandPage";
import { useAssignSettingFaireDirectSignUpFromMarketplaceEffect } from "@faire/retailer/settings/useSettingFaireDirectSignUpFromMarketplace";
import { useFaireDirectAutoSignUp } from "@faire/retailer/views/brand/logged-out/hooks/useFaireDirectAutoSignUp";
import { useLoggedOutBrandTracking } from "@faire/retailer/views/brand/logged-out/hooks/useLoggedOutBrandTracking";

export const ClientEffects: React.FC<{ brandToken: string }> = ({
  brandToken,
}) => {
  useEffect(() => {
    assignSettingRSCLoggedOutBrandPage();
  }, []);

  useAssignSettingFaireDirectSignUpFromMarketplaceEffect();

  useFaireDirectAutoSignUp();
  useLoggedOutBrandTracking(brandToken);

  return null;
};
